/* eslint-disable max-len */
import { HealthSurveillanceQuestionConfig, MedicalTypeId, MedicalTypeIds } from "../models";

import * as questionIds from "./questionIds";

const ManualHandlingMSKQuestionnaireQuestionMedicals: MedicalTypeId[] = [
    MedicalTypeIds.ManualHandlingMSKQuestionnaire,
    MedicalTypeIds.ManualHandlingMSKFaceToFaceAppointment,
    MedicalTypeIds.SafetyCriticalWorker,
    MedicalTypeIds.GroupOneDriving,
    MedicalTypeIds.GroupTwoDriving,
    MedicalTypeIds.WorkAtHeight,
    MedicalTypeIds.WorkingConfinedSpaces,
    MedicalTypeIds.WearingRPE,
    MedicalTypeIds.WearingBreathingApparatus,
    MedicalTypeIds.WorkingThermalEnvironment,
    MedicalTypeIds.Offshore,
    MedicalTypeIds.Airside,
    MedicalTypeIds.OtherFitnessToWork,
];

/**
 * @deprecated Prefer sections exported from `import { sections } from "../questionnaire";` which is in a data structure suitable for use with custom medicals
 */
export const section13Questions: HealthSurveillanceQuestionConfig[] = [
    {
        id: questionIds.HaveYouEverSufferedFromAnInjuryOrDisorderOfTheNeck,
        questionText: "Neck",
        medicalTypes: ManualHandlingMSKQuestionnaireQuestionMedicals
    },
    {
        id: questionIds.HaveYouEverSufferedFromAnInjuryOrDisorderOfTheShoulders,
        questionText: "Shoulders",
        medicalTypes: ManualHandlingMSKQuestionnaireQuestionMedicals
    },
    {
        id: questionIds.HaveYouEverSufferedFromAnInjuryOrDisorderOfTheArms,
        questionText: "Arms",
        medicalTypes: ManualHandlingMSKQuestionnaireQuestionMedicals
    },
    {
        id: questionIds.HaveYouEverSufferedFromAnInjuryOrDisorderOfTheWristHandsFingers,
        questionText: "Wrist/Hands/Fingers",
        medicalTypes: ManualHandlingMSKQuestionnaireQuestionMedicals
    },
    {
        id: questionIds.HaveYouEverSufferedFromAnInjuryOrDisorderOfTheUpperSpine,
        questionText: "Upper Spine",
        medicalTypes: ManualHandlingMSKQuestionnaireQuestionMedicals
    },
    {
        id: questionIds.HaveYouEverSufferedFromAnInjuryOrDisorderOfTheLowerSpine,
        questionText: "Lower Spine",
        medicalTypes: ManualHandlingMSKQuestionnaireQuestionMedicals
    },
    {
        id: questionIds.HaveYouEverSufferedFromAnInjuryOrDisorderOfTheLegsHipsKnees,
        questionText: "Legs/Hips/Knees",
        medicalTypes: ManualHandlingMSKQuestionnaireQuestionMedicals
    },
    {
        id: questionIds.HaveYouEverSufferedFromAnInjuryOrDisorderOfTheAnklesFeet,
        questionText: "Ankles/Feet",
        medicalTypes: ManualHandlingMSKQuestionnaireQuestionMedicals
    },
    {
        id: questionIds.MusculoskeltalInjuryOrDisordersDetails,
        questionText: "If YES, to any of the above, please give specific details:",
        medicalTypes: ManualHandlingMSKQuestionnaireQuestionMedicals
    },
    {
        id: questionIds.MusculoskeltalInjuryOrDisordersTreatmentMedicationDetails,
        questionText: "If YES, to any of the above please can you give specific details of any treatment received, including medication, physiotherapy or surgery?",
        medicalTypes: ManualHandlingMSKQuestionnaireQuestionMedicals
    },
    {
        id: questionIds.MusculoskeltalInjuryOrDisordersAffectingDailyLivingDetails,
        questionText: "If YES, to any of the above please can you advise if this injury/condition affects functioning in activities of daily living and if so what activities?",
        medicalTypes: ManualHandlingMSKQuestionnaireQuestionMedicals
    },
    {
        id: questionIds.WasTheInjuryConditionCausedOrMadeWorseByWork,
        questionText: "Was the injury/condition caused or made worse by work?",
        medicalTypes: ManualHandlingMSKQuestionnaireQuestionMedicals
    },
    {
        id: questionIds.DidYouReceiveAnyTreatment,
        questionText: "Did you receive any treatment?",
        medicalTypes: ManualHandlingMSKQuestionnaireQuestionMedicals
    },
    {
        id: questionIds.CausedWorseByWorkAndTreatmentDetails,
        questionText: "If YES, to any of the above, please give details:",
        medicalTypes: ManualHandlingMSKQuestionnaireQuestionMedicals
    },
    {
        id: questionIds.DoesTheInjuryConditionAffectYourAbilityToWork,
        questionText: "Does the injury/condition affect your ability to work?",
        medicalTypes: ManualHandlingMSKQuestionnaireQuestionMedicals
    },
    {
        id: questionIds.DoesTheInjuryConditionAffectYourAbilityToWorkDetails,
        questionText: "If YES, please give details:",
        medicalTypes: ManualHandlingMSKQuestionnaireQuestionMedicals
    },
];
/* eslint-enable max-len */
